import { Link } from "react-router-dom";

export const NotFound = () => {
  return (
    <>
      <div className="not-found-container">
        <h1>404 Not Found</h1>
        <p>The page you are looking for does not exist.</p>
        <Link to={"/"}>Go Back to Home Page</Link>
      </div>
    </>
  );
};
